import Vue from 'vue'
import App from './App.vue'
import i18n from './plugins/localization/i18n.js';
import router from './router'
import store from './store'
import mixin from './mixins/mixin'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import VueClipboard from 'vue-clipboard2'
import scrollTo from "vue-scrollto"
import * as CryptoJS from 'crypto-js'
import VueCookie from 'vue-cookie'
import Collapse from 'vue2-collapse'

Vue.use(scrollTo, {
    force: true,
    container: ".md-app-scroller",
    duration: 800,
    easing: "ease-in-out",
    offset: -60,
    onStart: function (element) {
        // console.log(element);
    },
    onDone: function (element) {
        // console.log(element);
    },
    onCancel: function () {
        // console.log('onCancel');
    },
});

Vue.use(VueCookie)

Vue.use(VueClipboard)
Vue.config.productionTip = true;
Vue.use(VueMaterial);
Vue.use(Collapse)
Vue.mixin(mixin);
Vue.filter('truncate', function (text, stop, clamp) {
    return text ? text.slice(0, stop) + (stop < text.length ? clamp || '...' : '') : text;
})

new Vue({
    i18n,
    router,
    store,
    CryptoJS,
    render: h => h(App)
}).$mount('#app');

// Use this fpr localization testing
i18n.locale = 'de';
